import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Map } from 'immutable';

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Checkbox from '@material-ui/core/Checkbox';
import CloseIcon from '@material-ui/icons/Close'

import Tag from 'components/common/Tag'

const WineBlock = props => {
    const { t } = useTranslation();
    const { data, wineInCart, allWineInCart, updateShippingCart } = props
    const onDelete = () => {
        const deleteItems = data
            .get('storageOrderItems')
            .map(item => item.get('id'))
        const updatedData = allWineInCart.filter(wineId => !deleteItems.includes(wineId))
        updateShippingCart(updatedData)
    }
    return (
        <Grid container className="wine-block bg-white">
            <CloseIcon className="close-icon pointer" onClick={onDelete}/>
            {/* wine photo */}
            <Grid item xs={2}
                className="wine-img"
                style={{
                    backgroundImage: `url(${data.get('imageUrl')})`,
                }}
            />
            <Grid item xs={10}>
                <Grid container style={{ padding: '16px 24px' }}>
                    <Grid container>
                        {/* title */}
                        <Grid item
                            style={{
                                maxHeight: '60px',
                                textOverflow: 'ellipsis', overflow: 'hidden'
                            }}
                        >
                            <Typography variant="h2" style={{lineHeight: '30px'}}>
                                {data.get('name')}
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* tag */}
                    <Grid container style={{ marginTop: '5px', marginBottom: '24px' }}>
                        <Tag tagName={data.get('country')} countryCode={data.get('countryCode')}/>
                        <Tag tagName={data.get('vintage')} />
                        <Tag tagName={t(`${data.get('color')}_wine`)} color={data.get('color')} />
                        <Tag tagName={!!data.get('style') && t(`wine_type_${data.get('style')}`)} />
                        <Tag tagName={`${data.get('volume')} ml`} />
                        <Tag tagName={data.get('grape')} grape />
                        <Tag tagName={data.get('region')} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid container style={{
                borderTop: '2px solid rgba(74, 79, 85, 0.1)',
                padding: '20px 30px'
            }}>
                {data.get('storageOrderItems').map(wine => {
                    const code = wine.get('code')
                    return (
                        <Grid key={code} item xs={3} style={{
                            border: '1px solid rgba(232, 232, 232)',
                            lineHeight: '30px',
                            textAlign: 'center',
                            margin: '-1px 0 0 -1px',
                        }}>
                            <Checkbox
                                checked={wineInCart.includes(wine.get('id'))}
                                onChange={props.updateWineInCart}
                                value={wine.get('id')}
                                color="primary"
                                style={{padding: '3px'}}
                              />
                            {code}
                        </Grid>
                    )
                })}
            </Grid>
        </Grid>
    )
}

export default WineBlock